import ShortcutIcon from '@atlaskit/icon/glyph/shortcut';
import { PARTNER_NAV_ITEMS } from '@atlassian/mpac-utils';
export const ReportsHeaderFilters = ['Start date', 'End date', 'Date range'];
export const Reports = [{
  label: 'Sales',
  value: 'sales',
  navItem: PARTNER_NAV_ITEMS.SALE_REPORTS,
  type: 'trends'
}, {
  label: 'Evaluations',
  value: 'evaluations',
  navItem: PARTNER_NAV_ITEMS.EVALUATIONS_REPORTS,
  type: 'trends'
}, {
  label: 'Feedback',
  value: 'feedback',
  navItem: PARTNER_NAV_ITEMS.FEEDBACK_REPORTS,
  type: 'trends'
}, {
  label: 'Cloud conversions',
  value: 'conversions',
  navItem: PARTNER_NAV_ITEMS.CLOUD_CONVERSIONS_REPORTS,
  type: 'trends'
}, {
  label: 'Cloud renewals',
  value: 'renewals',
  navItem: PARTNER_NAV_ITEMS.CLOUD_RENEWALS_REPORTS,
  type: 'trends'
}, {
  label: 'Cloud churn',
  value: 'churn',
  navItem: PARTNER_NAV_ITEMS.CLOUD_CHURN_REPORTS,
  type: 'trends'
}, {
  label: 'Transactions',
  value: 'transactions',
  navItem: PARTNER_NAV_ITEMS.TRANSACTIONS_REPORTS,
  type: 'explores'
}, {
  label: 'Licenses',
  value: 'licenses',
  navItem: PARTNER_NAV_ITEMS.LICENSES_REPORTS,
  type: 'explores'
}, {
  label: 'Feedback details',
  value: 'feedback-details',
  navItem: PARTNER_NAV_ITEMS.FEEDBACK_DETAILS_REPORTS,
  type: 'explores'
}, {
  label: 'Data API',
  value: '',
  type: 'data-api',
  icon: ShortcutIcon,
  isExternalLink: true
}];
export const Trends = ['sales', 'evaluations', 'feedback', 'conversions', 'renewals', 'churn'];
export const Explores = ['transactions', 'licenses', 'feedback-details'];
export const reportsWithTabFilterComponent = ['sales', 'evaluations'];
export const DateRange = [{
  label: 'All dates',
  value: undefined
}, {
  label: 'Last 30 days',
  value: 'past30Days'
}, {
  label: 'Last 90 days',
  value: 'past90Days'
}, {
  label: 'This month to date',
  value: 'thisMonth'
}, {
  label: 'Last month',
  value: 'lastMonth'
}, {
  label: 'Year to date',
  value: 'thisYear'
}, {
  label: 'Last year',
  value: 'lastYear'
}, {
  label: 'Custom',
  value: 'custom'
}];
export const SalesBy = [{
  label: 'Hosting',
  value: 'hosting'
}, {
  label: 'Sale type',
  value: 'type'
}, {
  label: 'Region',
  value: 'region'
}, {
  label: 'Country',
  value: 'country'
}];
export const EvaluationsBy = [{
  label: 'Hosting',
  value: 'hosting'
}, {
  label: 'Region',
  value: 'region'
}, {
  label: 'Country',
  value: 'country'
}];
export const FeedbackBy = [{
  label: 'Reason',
  value: undefined
}, {
  label: 'Type',
  value: 'type'
}];
export const FeedbackSource = [{
  label: 'New cloud reasons',
  value: undefined
}, {
  label: 'Manage apps',
  value: 'manageApps'
}, {
  label: 'Admin hub',
  value: 'adminHub'
}];
export const LicenseStatus = [{
  label: 'All',
  value: undefined
}, {
  label: 'Active',
  value: 'active'
}, {
  label: 'Expired',
  value: 'inactive'
}, {
  label: 'Cancelled',
  value: 'cancelled'
}];
export const LicenseType = [{
  label: 'All',
  value: undefined
}, {
  label: 'Evaluation',
  value: 'evaluation'
}, {
  label: 'Paid',
  value: 'paid'
}, {
  label: 'Free',
  value: 'free'
}];
export const Hosting = [{
  label: 'All',
  value: undefined
}, {
  label: 'Cloud',
  value: 'cloud'
}, {
  label: 'Server',
  value: 'server'
}, {
  label: 'Data Center',
  value: 'datacenter'
}];
export const SaleType = [{
  label: 'All',
  value: undefined
}, {
  label: 'New',
  value: 'new'
}, {
  label: 'Renewal',
  value: 'renewal'
}, {
  label: 'Upgrade',
  value: 'upgrade'
}, {
  label: 'Refund',
  value: 'refund'
}];
export const SaleChannel = [{
  label: 'All',
  value: undefined
}, {
  label: 'Expert',
  value: 'expert'
}, {
  label: 'Reseller',
  value: 'reseller'
}, {
  label: 'Direct',
  value: 'direct'
}];
export const BillingPeriodFilter = [{
  label: 'All',
  value: undefined
}, {
  label: 'Monthly',
  value: 'monthly'
}, {
  label: 'Annual',
  value: 'annual'
}];
export const TransactionsBooleanFilters = [{
  label: 'Include $0 transactions',
  value: 'zeroTransactions'
}];
export const Action = [{
  label: 'All',
  value: undefined
}, {
  label: 'Uninstalled',
  value: 'uninstall'
}, {
  label: 'Disabled',
  value: 'disable'
}, {
  label: 'Unsubscribed',
  value: 'unsubscribe'
}];
export const Author = [{
  label: 'All',
  value: undefined
}, {
  label: 'Anonymous',
  value: 'anonymous'
}, {
  label: 'Known',
  value: 'known'
}];
export const BaseResultsOn = [{
  label: 'License start dates',
  value: 'start'
}, {
  label: 'License end dates',
  value: 'end'
}];
export const FeedbackReasons = [{
  label: 'All reasons',
  value: 'all'
}, {
  label: 'App functionality',
  value: 'appFunctionality'
}, {
  label: 'App is expensive',
  value: 'expensive'
}, {
  label: 'We are moving to another cloud platform',
  value: 'migrate'
}, {
  label: 'I found a better alternative for this app',
  value: 'alternative'
}, {
  label: 'Customer support',
  value: 'customerSupport'
}, {
  label: 'The app did not meet my expectations',
  value: 'expectations'
}, {
  label: 'App design',
  value: 'appDesign'
}, {
  label: 'Other',
  value: 'other'
}];
export const ChurnBy = [{
  label: 'Rate',
  value: 'rate'
}, {
  label: 'Benchmark',
  value: 'benchmark'
}];